export type DirectionId = 'development' | 'ai-agents' | 'design' | 'smm' | 'marketing'
export type FilterId = 'all' | DirectionId

export const DIRECTION_FILTERS: Array<{ id: DirectionId; label: string }> = [
  { id: 'development', label: 'Разработка' },
  { id: 'ai-agents', label: 'ИИ-агенты' },
  { id: 'design', label: 'Дизайн' },
  { id: 'smm', label: 'SMM' },
  { id: 'marketing', label: 'Маркетинг' },
]

export const DIRECTION_FILTERS_WITH_ALL: Array<{ id: FilterId; label: string }> = [
  { id: 'all', label: 'Все' },
  ...DIRECTION_FILTERS,
]

const DIRECTION_KEYWORDS: Record<DirectionId, string[]> = {
  development: [
    'development',
    'разработка',
    'web',
    'веб',
    'website',
    'site',
    'сайт',
    'каталог',
    'crm',
    'pms',
    'platform',
    'платформа',
    'e-commerce',
    'ecommerce',
    'интернет-магазин',
    'онлайн-оплата',
    'бронь',
    'booking',
    'direct booking',
  ],
  'ai-agents': ['ai', 'ии', 'ai-agents', 'автоматизация', 'бот', 'chatbot', 'чат-бот', 'нейросеть'],
  design: ['design', 'дизайн', 'ui', 'ux', 'ui/ux', 'бренд', 'брендинг', 'айдентика'],
  smm: ['smm', 'смм', 'контент', 'соцсети', 'social', 'instagram', 'telegram'],
  marketing: [
    'marketing',
    'маркетинг',
    'performance',
    'перформанс',
    'seo',
    'контекст',
    'context',
    'лидогенерация',
    'аналитика',
    'локальный поиск',
  ],
}

function normalizeToken(value: string): string {
  return value.trim().toLowerCase().replace(/[ё]/g, 'е')
}

export function inferDirectionFromValues(
  values: Array<string | null | undefined>,
): DirectionId | null {
  const source = values.join(',').split(',').map(normalizeToken).filter(Boolean)

  for (const direction of DIRECTION_FILTERS) {
    if (source.some((token) => DIRECTION_KEYWORDS[direction.id].some((kw) => token.includes(kw)))) {
      return direction.id
    }
  }

  return null
}

export function directionFromCaseCategory(category: string | null | undefined): DirectionId | null {
  const normalized = normalizeToken(category || '')
  if (!normalized) return null
  if (normalized === 'web') return 'development'
  if (normalized === 'ai') return 'ai-agents'
  if (normalized === 'design') return 'design'
  if (normalized === 'smm') return 'smm'
  if (normalized === 'seo' || normalized === 'context') return 'marketing'
  return null
}

export const NEWS_DIRECTION_OPTIONS: Array<{ value: DirectionId; label: string }> = [
  { value: 'development', label: 'Разработка' },
  { value: 'ai-agents', label: 'ИИ-агенты' },
  { value: 'design', label: 'Дизайн' },
  { value: 'smm', label: 'SMM' },
  { value: 'marketing', label: 'Маркетинг' },
]

export function directionFromNewsCategory(category: string | null | undefined): DirectionId | null {
  const normalized = normalizeToken(category || '')
  if (!normalized) return null
  if (normalized === 'development' || normalized === 'разработка') return 'development'
  if (normalized === 'ai-agents' || normalized === 'ai' || normalized === 'ии') return 'ai-agents'
  if (normalized === 'design' || normalized === 'дизайн') return 'design'
  if (normalized === 'smm' || normalized === 'смм') return 'smm'
  if (
    normalized === 'marketing' ||
    normalized === 'маркетинг' ||
    normalized === 'seo' ||
    normalized === 'context'
  ) {
    return 'marketing'
  }
  return null
}

export function directionLabel(id: DirectionId): string {
  return DIRECTION_FILTERS.find((item) => item.id === id)?.label || 'Разработка'
}

export function formatNewsCategoryLabel(category: string | null | undefined): string {
  const direction = directionFromNewsCategory(category)
  return direction ? directionLabel(direction) : category?.trim() || 'Разработка'
}
